<template>
    <v-form 
    ref="form"
    v-model="valid"
    >
    <v-container>
        <v-row no-gutters>
            <v-col cols="4">
                <v-text-field dense outlined
                v-model="c_data.w_type"
                label="tipo pesiera"
                :rules="[rules.mandatory]"
                :readonly="preview"
                />
            </v-col>
            <v-col cols="4" class="pl-2">
                <v-text-field dense outlined
                v-model="c_data.w_model"
                label="modello pesiera"
                :rules="[rules.mandatory]"
                :readonly="preview"
                />
            </v-col>
            <v-col cols="4" class="pl-2">
                <v-select dense outlined
                v-model="c_data.w_class"
                label="classe pesiera"
                :items="classes"
                item-text="text"
                item-value="id"
                :readonly="preview"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6">
                <v-text-field dense outlined
                v-model="c_data.w_manufacturer"
                label="Costruttore pesi"
                :rules="[rules.mandatory]"
                :readonly="preview"
                />
            </v-col>
            <v-col cols="6" class="d-flex align-middle pl-2">
                <v-select dense outlined
                    :items="uoms"
                    v-model="c_data.uom"
                    item-text="text"
                    item-value="id"
                    label="unità misura masse*"
                    :rules="[rules.mandatory]"
                    :readonly="preview"
                ></v-select>
                <v-text-field dense outlined
                    class="pl-2"
                    label="unità misura incertezza"
                    v-model="computedU"
                    disabled
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
        <v-col cols="12">
            <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right" v-for="head of compHeaders" :key="head.value">{{head.text}}<br/> <i class="caption" v-if="head.uom">({{head.uom}})</i></th>
                    </tr>
                </thead>
                <tr v-for="(w_item,idx) of c_data.values" :key="idx">
                    <td v-for="head of compHeaders" :key="head.value" class="table-blocks text-right">
                        <v-select dense outlined
                        v-if="head.value == 'class'"
                        v-model="w_item[head.value]"
                        :items="classes"
                        hide-details
                        item-text="text"
                        item-value="id"
                        :readonly="preview"
                        />
                        <v-text-field
                            v-else-if="head.value == '_id'"
                            dense outlined
                            hide-details
                            required
                            :rules="[rules.mandatory]"
                            :readonly="preview"
                            v-model="w_item[head.value]"
                        />
                        <v-text-field
                            v-else-if="head.value == 'manufacturer'"
                            dense outlined
                            hide-details
                            required
                            :rules="[rules.mandatory]"
                            :readonly="preview"
                            v-model="w_item[head.value]"
                        />
                        <NumericField dense outlined
                            v-else
                            hide-details
                            required
                            v-model="w_item[head.value]"
                            :rules="[rules.mandatory]"
                            :readonly="preview"
                        ></NumericField>
                    </td>
                    <td v-if="!preview">
                        <v-btn color="action" fab small @click.stop="deleteRow(w_item)"><v-icon>delete</v-icon></v-btn>
                    </td>
                </tr>
            </template>
            </v-simple-table>
        </v-col>
        </v-row>
        <v-row no-gutters v-if="notUnique">
            <v-alert type="error">
                Controllare le matricole, sono presenti duplicati
            </v-alert>
        </v-row>
        <v-row no-gutters v-if="!preview">
            <v-col cols="12" class="d-flex justify-end my-3">
                <v-btn color="action" @click="addRow" class="ml-2"><v-icon>add_box</v-icon>Aggiungi massa</v-btn>
            </v-col>
        </v-row>
    </v-container>
    </v-form>
</template>
<script>
const nerdamer = require('nerdamer/all')
import {getModel} from "../../utils/model"
import {f_rules} from '../../utils/commonUtils'
// import _ from 'lodash'

export default {
    components: {},
    props: {
        'data':{
            type: Object,
            required: true
        }, 
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            c_data: null,
            items: [],
            valid: false,
            rules: f_rules,
            csvfiles: [],
            pagination: {'rowsPerPage': -1},
            classes: null,
            uoms: null,
            notUnique: false,
            formula_max: null,
            formula_min: null
        }
    },
    async beforeMount() {
        console.log("debug: data", this.data, this.c_data)
        if(this.data && this.data.block && this.data.block.model){
            this.uoms = this.data.block.uoms
            this.classes = this.data.block.classes
            if (_.isEmpty(this.data.p_data)){
                let Model = getModel(this.data.block.model)
                this.c_data = Model()
                if(this.data.instrument){
                    this.c_data.instrument = this.data.instrument
                }
            } else {
                this.c_data = _.cloneDeep(this.data.p_data)
            }
        } else {
            console.log("debug: error", this.data)
        }
        await this.findFormulas()
    },
    computed: {
        compHeaders(){
            console.log("debug: building headers")
            let dictionary = this.c_data.header
            let that = this
            var values = Object.keys(dictionary).map(function(key){
                let r_val = {text: dictionary[key], value: key}
                switch(key) {
                    case 'name':
                    case 'conv':
                        r_val.uom = that.c_data.uom
                        break
                    case 'uncertain_ext':
                        r_val.uom = that.computedU
                        break
                }
                return r_val
            });
            console.log("debug: headers value", values )
            return values
        },
        computedU(){
            if(this.c_data.uom){
                switch(this.c_data.uom){
                    case "g": return "mg"
                    case "kg": return "g"
                }
            }
            return ""
        },
        
    },
    methods: {
        findFormulas(){
            this.$store.state.$pouch.find('masters', {selector: {_id: 'formula:massimo'}}).then(
            res => {
                if(res.docs.length > 0){
                    this.formula_max = res.docs[0]
                }
            })
            this.$store.state.$pouch.find('masters', {selector: {_id: 'formula:minimo'}}).then(
            res => {
                if(res.docs.length > 0){
                    this.formula_min = res.docs[0]
                }
            })
            
        },
        checkIDUniqueness(){
            let uniques = _.uniqBy(this.c_data.values, '_id')
            return uniques.length != this.c_data.values.length
        },
        addRow(){
            let dictionary = {}
            for(let key of Object.keys(this.c_data.header)){
                dictionary[key] = null
            }
            dictionary['manufacturer'] = _.cloneDeep(this.c_data.w_manufacturer)
            dictionary['class'] = this.c_data.w_class
            // dictionary['instrument'] = this.c_data.instrument            This is wrong!!!
            this.c_data.values.push(dictionary)
        },
        deleteRow(item){
            let n = this.c_data.values.indexOf(item)
            console.log("valore trovato:", n)
            this.c_data.values.splice(n,1)
            this.exportData()
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-csv file
                if (!/\.(csv)$/i.test(newFile.name)) {
                return prevent()
                }
            }
        },
        // processFile(){
        //     console.log("test file input", this.csvfiles[0])
        //     this.$papa.parse(this.csvfiles[0].file, {header: true, skipEmptyLines: 'greedy', complete: (results) => {
        //         this.items = results.data
        //         console.log("results parsing", this.items)
        //         // let cose = this.$papa.unparse(results)
        //         // console.log("tentativo 2", cose)
        //         // this.download("esempio.csv", cose)
        //     }})
        // },
        getData() {
            return this.c_data
        },
        exportData(){
            if(this.c_data){
                this.$parent.$emit('autoUpdate', this.c_data)
            }
        },
        findMax(items){
            if(this.formula_max){
                let paramName = Object.keys(this.formula_max.data)[0] // name of the variable, like a in stdev(a)
                var test = this.formula_max.equation.replace(paramName, items.toString())
                let pippo = nerdamer(test).evaluate().text()
                return pippo
            }
            else{
                return 0
            } 
        },
        findMin(items){
            if(this.formula_min){
                let paramName = Object.keys(this.formula_min.data)[0] // name of the variable, like a in stdev(a)
                var test = this.formula_min.equation.replace(paramName, items.toString())
                let pippo = nerdamer(test).evaluate().text()
                return pippo
            }
            else{
                return 0
            } 
        },
        updateStats(){
            let minmax = this.c_data.values.reduce((acc, val) => {
                acc.max = ( val.name && val.name > acc.max ) ? val.name : acc.max
                acc.min = ( val.name && val.name < acc.min) ? val.name : acc.min
                acc.u_max = ( val.uncertain_ext && val.uncertain_ext > acc.u_max ) ? val.uncertain_ext : acc.u_max
                acc.u_min = ( val.uncertain_ext && val.uncertain_ext < acc.u_min) ? val.uncertain_ext : acc.u_min
                acc.tot = val.name ? acc.tot + parseFloat(val.name) : acc.tot
                return acc;
            }, {min: Number.POSITIVE_INFINITY, max: 0, u_min: Number.POSITIVE_INFINITY, u_max: 0, tot: 0})
            let items = this.c_data.values.map(item => item.name)
            let items_U = this.c_data.values.map(item => item.uncertain_ext)
            // let sum = this.c_data.values.reduce((a,b) => {
            //     b.name ? Big(a).plus(b.name).toString() : a
            // }, 0)
            // console.log("minmax: ", minmax)
            // this.c_data.min_weight = minmax.min
            // this.c_data.max_weight = minmax.max
            // this.c_data.min_u = minmax.u_min
            // this.c_data.max_u = minmax.u_max
            // this.c_data.weightTotal = minmax.tot
            this.c_data.min_weight = this.findMin(items)
            this.c_data.max_weight = this.findMax(items)
            this.c_data.min_u = this.findMin(items_U)
            this.c_data.max_u = this.findMax(items_U)
            this.c_data.weightTotal = minmax.tot
            console.log("$$ c_data changed", this.c_data)
            this.notUnique = this.checkIDUniqueness()
        }
    },
    watch: {
        'valid':{
            handler() {
                this.$parent.$emit('validitySpecific', this.valid && !this.notUnique)
            }
        },
        'notUnique':{
            handler(){
                if(this.notUnique){
                    this.$parent.$emit('validitySpecific', false)
                } else {
                    this.$parent.$emit('validitySpecific', this.valid)
                }
            }
        },
        'c_data.values':{
            deep: true,
            handler(){
                this.updateStats()
            }
        },
    }
}
</script>